import i18n from 'app/i18/i18'

import type { RealtyType } from 'shared/api/kyrgyzstan/search'

export const prepareRealtyTypeFilterOptions = (
  realtyTypes: RealtyType[],
  noneOptionName?: string,
): RealtyType[] => {
  const anyOption: RealtyType = {
    id: 0,
    name: noneOptionName || i18n.t('all'),
    icon: undefined,
  }
  return [anyOption, ...realtyTypes]
}
